import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import BeforeLoginMenu from "../../routes/BeforeLoginMenu";
import AfterLoginMenu from "../../routes/AfterLoginMenu";
import axios from "axios";

class InsuranceList extends Component {
    constructor(props) {
        super(props);

        const token = localStorage.getItem("token");
        // if (!token) {
        //   this.props.history.push("/login");
        // }

        this.state = {
            token: token,
            items: [],
            states: [],
            msa: [],
        };

        this.handleStateChange = this.handleStateChange.bind(this);
    }

    refreshToken() {
        const token = localStorage.getItem("token");
        const refreshToken = localStorage.getItem("refreshToken");
        const expired = localStorage.getItem("expired");

        if (token !== null && refreshToken !== null && expired !== null) {
            axios
                .post(`${process.env.REACT_APP_API_URL}api/auth/refreshToken`, {
                    token: token,
                    refreshToken: refreshToken,
                    expiration: expired,
                })
                .then((response) => {
                    localStorage.removeItem("token");
                    localStorage.removeItem("refreshToken");
                    localStorage.removeItem("expired");
                    localStorage.setItem("token", response.data.token);
                    localStorage.setItem("refreshToken", response.data.refreshToken);
                    localStorage.setItem("expired", response.data.expiration);
                })
                .catch((error) => {
                    if (
                        error.response.status === 400 ||
                        error.response.status === 401 ||
                        error.response.status === 403
                    ) {
                        localStorage.removeItem("token");
                        localStorage.removeItem("email");
                        localStorage.removeItem("userID");
                        localStorage.removeItem("userName");
                        localStorage.removeItem("secret_key");
                        localStorage.removeItem("refreshToken");
                        localStorage.removeItem("expired");
                        this.props.history.push("/login");
                    }
                });
        }
    }

    getInsuranceList() {
        axios
            .get(`${process.env.REACT_APP_API_URL}api/Inventory/InsuranceInventoryListings`, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`,
                    secret_key: localStorage.getItem("secret_key"),
                },
            })
            .then((response) => {
                this.setState({
                    items: Object.values(response.data),
                });
            })
            .catch((error) => {
                if (
                    error.response.status === 400 ||
                    error.response.status === 401 ||
                    error.response.status === 403
                ) {
                    localStorage.removeItem("token");
                    localStorage.removeItem("email");
                    localStorage.removeItem("userID");
                    localStorage.removeItem("userName");
                    localStorage.removeItem("secret_key");
                    localStorage.removeItem("refreshToken");
                    localStorage.removeItem("expired");
                    this.props.history.push("/login");
                }
            });
    }

    getAllState() {
        axios
            .get(`${process.env.REACT_APP_API_URL}api/master/getallstates`, {})
            .then((response) => {
                this.setState({
                    states: Object.values(response.data),
                });
            })
            .catch((error) => {
                if (
                    error.response.status === 400 ||
                    error.response.status === 401 ||
                    error.response.status === 403
                ) {
                    localStorage.removeItem("token");
                    localStorage.removeItem("email");
                    localStorage.removeItem("userID");
                    localStorage.removeItem("userName");
                    localStorage.removeItem("secret_key");
                    localStorage.removeItem("refreshToken");
                    localStorage.removeItem("expired");
                    this.props.history.push("/login");
                }
            });
    }
    getAllMsa() {
        axios
            .get(
                `${process.env.REACT_APP_API_URL}api/inventory/getmsabystatename?state={stateName:''}`,
                {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`,
                        secret_key: localStorage.getItem("secret_key")
                    },
                }
            )
            .then((response) => {
                this.setState({
                    msa: Object.values(response.data),
                });
            })
            .catch((error) => {
                if (
                    error.response.status === 400 ||
                    error.response.status === 401 ||
                    error.response.status === 403
                ) {
                    localStorage.removeItem("token");
                    localStorage.removeItem("email");
                    localStorage.removeItem("userID");
                    localStorage.removeItem("userName");
                    localStorage.removeItem("secret_key");
                    localStorage.removeItem("refreshToken");
                    localStorage.removeItem("expired");
                    this.props.history.push("/login");
                }
            });
    }



    handleStateChange(event) {
        axios
            .get(
                `${process.env.REACT_APP_API_URL}api/inventory/getmsabystatename?state={stateName:'${event.target.value}'}`,
                {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`,
                        secret_key: localStorage.getItem("secret_key"),
                    },
                }
            )
            .then((response) => {
                this.setState({
                    msa: Object.values(response.data),
                });
            })
            .catch((error) => {
                if (
                    error.response.status === 400 ||
                    error.response.status === 401 ||
                    error.response.status === 403
                ) {
                    localStorage.removeItem("token");
                    localStorage.removeItem("email");
                    localStorage.removeItem("userID");
                    localStorage.removeItem("userName");
                    localStorage.removeItem("secret_key");
                    localStorage.removeItem("refreshToken");
                    localStorage.removeItem("expired");
                    this.props.history.push("/login");
                }
            });
    }

    componentDidMount() {
        //this.getInsuranceList();
        this.getAllMsa();
        this.refreshToken();
        this.getAllState();
        // this.getAllHospital();
        const script = document.createElement("script");
        script.async = true;
        script.src = "/js/insurance_custom.js";
        this.div.appendChild(script);
    }

    render() {
        return (
            <>
                {this.state.token !== null ? <AfterLoginMenu /> : <BeforeLoginMenu />}
                <main role="main">
                    <div className="gredient-bg pt-3 pb-5" ref={(el) => (this.div = el)}>
                        <div className="container">
                            <div className="row  new-invdeopdown-filters m-0 mb-3 justify-content-center">
                                <div className="col-md-4 col-sm-12 inventory-filter-col pt-4 text-white  row align-items-center">
                                    <label className="bold_text pr-3">
                                        STATE NAME:
                                    </label>
                                    <select
                                        className="mdb-select md-form drpdownList"
                                        //onChange={this.handleStateChange}
                                        id="stateList"
                                    >
                                        <option value="" selected>
                                            Select State
                                        </option>
                                        {this.state.states.map((stateArr, index) => (
                                            <option value={stateArr.stateName}>
                                                {stateArr.stateName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-4 col-sm-12 inventory-filter-col pt-4 text-white    row align-items-center">
                                    <label className="bold_text pr-3 ">
                                        MSA:
                                    </label>
                                    <select
                                        className="mdb-select md-form drpdownList"
                                        //onChange={this.handleStateChange}
                                        id="msaList"
                                    >
                                        <option value="" selected>
                                            Select MSA
                                        </option>
                                        {this.state.msa.map((msaArr, index) => (
                                            <option value={msaArr.msaID}>{msaArr.msaName}</option>
                                        ))}
                                    </select>

                                </div>


                            </div>

                            <div className="input-group">
                                <div className="col-md-12">
                                    <table
                                        className="table table-borderless table-blue table table-striped table-bordered table-sm"
                                        id="tbl_inc_inventory"
                                    //ref="inventoryTbl" 
                                    >
                                        <thead>
                                            <tr>
                                                <th scope="col">
                                                    State Name
                                                </th>
                                                <th scope="col">
                                                    MSA Name
                                                </th>
                                                <th scope="col">
                                                    Payor
                                                </th>
                                                <th scope="col">
                                                    Specialty
                                                </th>
                                                 <th scope="col">
                                                    Tax ID
                                                </th>
                                                <th scope="col">
                                                    NPI1
                                                </th>

                                                {/* <th scope="col">
                                                    NPI2
                                                </th> */}
                                                
                                                <th scope="col">
                                                    Business Name
                                                </th>
                                                
                                                {/* <th scope="col">
                                                    NPI Provider
                                                </th> */}
                                            </tr>
                                        </thead>
                                        <tbody>

                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </div>
                    </div>
                </main>
            </>
        );
    }
}
export default withRouter(InsuranceList);
